module.exports = __webpack_public_path__ + "static/media/banner1.21fbdc8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/ziersch/images/banner1.jpg
// module id = 473
// module chunks = 0